import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Contact, Titre } from '../entity/Contact';
import { HttpErrorResponse, HttpClient, HttpHeaders } from '@angular/common/http';
 
import { catchError, tap } from 'rxjs/operators';
 import { environment } from 'src/environments/environment';
import { MessageService } from 'primeng/api';


const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};


@Injectable( )
export class ContactService {

  constructor(private messageService: MessageService,
    private http: HttpClient ) { }

    private baseUrl = environment.restApi;
    private contactUrl = `${this.baseUrl}contact`;

    getContact(id: number): Observable<Contact> {
      const url = `${this.contactUrl}/${id}`;
      return this.http
          .get<Contact>(url)
          .pipe(
              tap(_ => this.notify(`fetched delegate id=${id}`, 'GET')),
              catchError(this.handleError(`getDelegate id=${id}`, 'GET'))
          );
  }
  findContactsByProspect(IdProspect: Number): Observable<Contact[]> {

    return  this.http
      .get<Contact[]>(this.contactUrl +`/prospect/` + IdProspect )
      .pipe(
        tap(_ => this.notify('fetched contacts', 'GET')),
        catchError(this.handleError('getContacts', 'GET'))
    );
}
findContactsByProspectUrl(IdProspect: Number,url:String): Observable<Contact[]> {

  return  this.http
    .get<Contact[]>(  `${url}contact/prospect/` + IdProspect )
    .pipe(
      tap(_ => this.notify('fetched contacts', 'GET')),
      catchError(this.handleError('getContacts', 'GET'))
  );
}

   /** 
     * POST: add a new exhibitor to the database 
     */
    addContact(contact: Contact): Observable<any> {
      return this.http
          .post<Contact>(this.contactUrl, contact, httpOptions)
          .pipe(
              tap((contact: Contact) => this.notify(`added hero w/ id=${contact.contactId}`, 'POST')),
              catchError(this.handleError('addContact', 'POST'))
          );
  }
  deleteContact(contact: Contact  ): Observable<any> {
    const id =   contact.contactId;
    const url = `${this.contactUrl}/${id}`;
    return this.http
        .delete<Contact>(url, httpOptions)
        .pipe(
            tap(_ => this.notify(`deleted contact id=${id}`, 'DELETE')),
            catchError(this.handleError('deleteContact', 'DELETE'))
        );
}

saveContact(contact:Contact) : Observable<any> {
    return this.http
        .put(this.contactUrl+'/'+contact.contactId, contact, httpOptions)
        .pipe(
            tap(_ => this.notify(`updated contact id=${contact.contactId}`, 'PUT')),
            catchError(this.handleError('updateContact', 'PUT'))
        );
 
}
private subject = new Subject<any>();
 
selectContact(contact: Contact) {
    this.subject.next(  contact );
}

unselectContact() {
    this.subject.next();
}

getSelectedContact(): Observable<any> {
    return this.subject.asObservable();
}
 
getPositionByDesignation(designation: string): Observable<Titre[]> {
  let titre$ = this.http
    .get<Titre[]>(this.baseUrl + 'titre/designation/' + designation ) ;
  return titre$;
}
 /**
     * Prepare an error handler for failed HTTP requests.
     * That handler extracts the error message and logs it.
     * It also adds the message to the errors$ observable to which the caller
     * may listen and react.
     * @param operation The name/description of the operation that failed
     * @param method The HTTP method for the failed HTTP request
     */
    protected handleError(operation: string, method: string) {
      return function errorHandler(res: HttpErrorResponse) {
      
       //   this.logger.error(res);
         // const eMsg = res.message || '';
         /* const error = `${this.entityNamePlural} ${operation} Error${
              eMsg ? ': ' + eMsg : ''
              }`;*/
              this.messageService.add({severity:'error', summary:"Vous n'etes pas entrain d'ecrire", detail:"Veuillez contacter votre support"});
         
      }.bind(this);
  }
  protected notify(message: string, method: string) {
  //  this.messageService.add({severity:'success', summary:method, detail:message});
  }

}
